const en = {
  message: {
    Save_cmd: 'Save',
    Cancel_cmd: 'Cancel',
    Close_cmd: 'Close',
    Edit_cmd: 'Edit',
    Del_cmd: 'Delete',
    Query_cmd: 'Query',
    Send_cmd: 'Send',
    Sign_in: 'Sign in',
    Confirm_txt: 'OK',
    Load_txt: 'Loading',
    Error_txt: 'Error',
    Success_txt: 'Success',
    Warning_txt: 'Warning',
    Info_txt: 'Info',
    Upload_txt: 'Upload',
    Back_txt: 'Back',
    Next_txt: 'Next',
    Keep_txt: 'Keep',
    Check_txt: 'Check',
    Contact_txt: 'Contact Us',
    Home_txt: 'NCUT Home',
    Preview_txt: 'Preview',
    NextPage_txt: 'Next'
  } 
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js